import { OverrideReason } from '../types/hotLead'

/**
 * Reason codes + subcodes logged whenever the manager overrides the system's
 * "hot" call. Override data is what refines the grading rules over time.
 */
export const overrideReasons: OverrideReason[] = [
  {
    code: 'RATE',
    label: 'Rate does not qualify',
    subcodes: [
      'Below spread threshold',
      'Rate data stale',
      'Buydown already applied',
    ],
  },
  {
    code: 'EQUITY',
    label: 'Equity issue',
    subcodes: [
      'Estimated value inflated',
      'Insufficient equity for cash-out',
      'Second lien not accounted for',
    ],
  },
  {
    code: 'CONTACT',
    label: 'Conversation not meaningful',
    subcodes: [
      'Wrong party reached',
      'Borrower declined',
      'Call under 30 seconds',
    ],
  },
  {
    code: 'CREDIT',
    label: 'Credit / eligibility',
    subcodes: ['Credit pull too old', 'Score below program', 'Recent denial'],
  },
  {
    code: 'TIMING',
    label: 'Timing',
    subcodes: ['Seasoning not met', 'Borrower asked for later follow-up'],
  },
  {
    code: 'DNQ',
    label: 'Does not qualify (DNQ)',
    subcodes: ['Property type', 'Occupancy', 'Bankruptcy / foreclosure'],
  },
]
